/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ChildBabyIcon16Solid = forwardRef('ChildBabyIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" }),
        React.createElement("path", { d: "M1.293 3.293a1 1 0 0 1 1.414 0L6.414 7h3.172l3.707-3.707a1 1 0 1 1 1.414 1.414L11 8.414V9.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V8.414L1.293 4.707a1 1 0 0 1 0-1.414Z" }),
        React.createElement("path", { d: "M6.092 12.44a1 1 0 1 0-.684-1.88l-2.012.732a1.5 1.5 0 0 0-.548 2.47l1.945 1.945a1 1 0 0 0 1.414-1.414l-1.39-1.39 1.275-.463Z" }),
        React.createElement("path", { d: "M10.592 10.56a1 1 0 0 0-.684 1.88l1.275.463-1.39 1.39a1 1 0 1 0 1.414 1.414l1.945-1.945a1.5 1.5 0 0 0-.548-2.47l-2.012-.732Z" })));
});
